export enum LineStyle {
  Solid = 'solid',
  Dotted = 'dotted',
}
